import * as _ from 'lodash';
import { DEFAULT_LABELS } from '../../../../../../shared/labels';

// Sorts labels keeping the default labels at the top of the list
export const sortLabels = (labels: string[]): string[] => {
  const [defaultLabelsInUse, labelsWithoutDefaults] = _.partition(labels, (label) => DEFAULT_LABELS.includes(label));

  return [...defaultLabelsInUse, ...labelsWithoutDefaults.sort()];
};
